var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"dashboard","fluid":"","tag":"section"}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('food-chart-card')],1),_c('v-col',{attrs:{"cols":"12","lg":"6"}},[_c('weight-chart-card')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }